// ----------------------------------------------------------------------
// <copyright file="Izenda.SecurityConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  BUNDLE: {
    TOOLTIP: {
      get TENANT_TOOLTIP() {
        return localizer.getText('SECURITY_TENANT_TOOLTIP');
      },
      get SHOW_TENANT_TOOLTIP() {
        return localizer.getText('SECURITY_SHOW_TENANT_TOOLTIP');
      },
      get VISIBLE_FIELD_TOOLTIP() {
        return localizer.getText('SECURITY_VISIBLE_FIELD_TOOLTIP');
      },
      get FILTERABLE_FIELD_TOOLTIP() {
        return localizer.getText('SECURITY_FILTERABLE_FIELD_TOOLTIP');
      },
      get RESET_TENANT_FIELD_TOOLTIP() {
        return localizer.getText('SECURITY_RESET_TENANT_FIELD_TOOLTIP');
      },
      get RENDER_HTML_IN_REPORT_VIEWER_TOOLTIP(){
        return localizer.getText('SECURITY_RENDER_HTML_IN_REPORT_VIEWER_TOOLTIP');
      },
    },
    LABEL: {
      get TENANT_FIELD_LABEL() {
        return localizer.getText('SECURITY_LABEL_TENANT_FIELD');
      },
      get SHOW_TENANT_FIELD_LABEL() {
        return localizer.getText('SECURITY_LABEL_SHOW_TENANT_FIELD');
      },
      get VISIBLE_FIELD_LABEL() {
        return localizer.getText('SECURITY_LABEL_ADDITIVE_FIELDS_AUTO_VISIBLE');
      },
      get FILTERABLE_FIELD_LABEL() {
        return localizer.getText('SECURITY_LABEL_ADDITIVE_FIELDS_AUTO_FILTERABLE');
      },
      get SECURITY_RENDER_HTML_EXPORT(){
        return localizer.getText('SECURITY_RENDER_HTML_EXPORT');
      },
      get RENDER_HTML_IN_REPORT_VIEWER_LABEL(){
        return localizer.getText('SECURITY_LABEL_RENDER_HTML_IN_REPORT_VIEWER');
      },
      get SYSTEM_TENANT_FIELD_LABEL() {
        return localizer.getText('SECURITY_LABEL_SYSTEM_TENANT_FIELD');
      }
    },
    TEXT: {
      get TENANT_FIELD_NO_RESULT_TEXT() {
        return localizer.getText('SECURITY_TENANT_FIELD_NO_RESULT_TEXT');
      }
    }
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.SecurityConstants.js